<template>
  <div class="info-query">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
    </van-nav-bar>

    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <!-- <div class="top-tip">
      <div class="top-tip-txt">
        账单说明：网上营业厅提供近一年的用水信息，如需更多清单信息请咨询服务热线96390或至各服务网点进行咨询。
      </div>
    </div> -->
    <p style="font-size: 15px;z-index: 1;color: #2378f7;padding: 10px;margin: 0px auto;position: absolute; right: 0px;" @click.stop="dialogShow = !dialogShow">切换缴费号</p>
    <van-field v-model="fuserno" label="缴费号：" readonly />
    <van-field v-model="fname" label="用户名称：" readonly />
    <van-field v-model="form.usad" label="装表地址：" readonly />
    <van-field v-model="form.chst" label="抄表周期：" readonly />
    <van-field v-model="form.toam" label="本期抄表日期：" readonly />
    <van-popup v-model="dialogShow" position="bottom" :style="{ height: '30%' }">
      <van-picker title="缴费号选择" show-toolbar :columns="userColumns" @confirm="onConfirm" @cancel="dialogShow = false" />
    </van-popup>
    <div style="margin-top: 7px"></div>
    <div class="chat-con" v-show="false">
      <p>阶梯年用水量</p>
      <van-row>
        <van-col span="14">
          <gauge></gauge>
        </van-col>
        <van-col span="10">
          <div class="label">
            <p>用户号：<span>{{fuserno}}</span></p>
            <!-- <p>口径钢号：<span>15C-505647</span></p> -->
            <p>装表地址：<span>{{form.usad}}</span></p>
            <!-- <p>阶梯年用水量：<span>0 立方米</span></p>
                    <p>目前阶梯：<span>第一阶梯</span></p>
                    <p>距第一阶梯：<span>204 立方米</span></p> -->
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="chat-bottom">
      <div class="label-left">
        <div class="label-bot">
          <p>本期水量</p>
          <div class="info"><span>{{form.wtva}}</span>立方米</div>
        </div>
        <div class="label-bot">
          <p>本期费</p>
          <div class="info"><span>{{form.tham}}</span>元</div>
        </div>
      </div>
      <div class="button-right">
        <van-button size="small" type="info" plain @click="isshowClick" round>用水账单</van-button>
      </div>
    </div>
    <div class="waterFee">
      <div class="waterFee——title">历史用水变化</div>
      <!-- <div class="waterFee——head">
        <div class="waterFee——head__lift">
          <span @click.stop="dialogShow = !dialogShow">缴费号：{{ fuserno }}
            <span class="iconfont iconxiala" style="font-size: 12px"></span
          ></span>
        </div>
      </div> -->
      <div class="waterFee——content" ref="accessChart"></div>
    </div>
    <!--列表样式-->
    <van-popup v-model="isshow" closeable position="bottom" :style="{ height: '70%',background:'#f5f5f5'}">
      <div class="bill-bg">用水账单</div>
      <!-- <p class="bill-p">账单下载（W23181120201226.xls）</p> -->
      <div class="Water-bill" v-for="(water, i) in waterCostList" :key="i">
        <div class="bill-circle">
          <span>{{water.month}}</span><em>/</em>
          <p>{{water.year}}</p>
        </div>
        <div class="bill-con">
          <p>用水量：<span>{{water.WTVA}}</span></p>
          <p>本期抄见：<span>{{water.PNVA}}</span></p>
          <!-- <p>换表底数：<span>0</span></p> -->
          <p>抄表日期：<span>{{water.TOAM}}</span></p>
        </div>
        <div class="bill-rig">
          <p>¥{{water.THAM}}</p>
          <!-- 已缴 -->
        </div>
      </div>
    </van-popup>

    <div class="comm-homebar-height"></div>

    <home-bar v-show="false"></home-bar>
  </div>
</template>

<script>
import HomeBar from "@/components/HomeBar.vue";
let EChart = require("echarts")
export default {
  name: "FeeList",
  components: {
    HomeBar,
  },
  data() {
    return {
      isshow: false,
      userColumns: [],
      waterCostList: [],
      dialogShow: false,
      fname: '',
      fuserno: '',
      form: {
        wtva: 0, //用水量
        tham: 0, // 水费
        usad: '',
        chst: '', //抄表周期
        toam: '', //最后抄表日期
      },
    };
  },
  created() {

  },
  mounted() {
    this.getUserList()
  },
  methods: {
    // 用水账单
    isshowClick() {
      this.isshow = true
    },
    // 查询用户绑定户号
    getUserList() {
      this.$http.post(this.$api.userList, { pageindex: 1, pagesize: 20 }).then(res => {
        if (res.code === '000') {
          this.userList = res.data
          // 有绑定账号
          if (this.userList.length > 0) {
            // 查询水费账单
            let data = this.userList.filter(item => item.ftypeid == 0)
            if (data && data.length > 0) {
              this.fuserno = data[0].fuserno
              this.fname = data[0].fname
              data.forEach(el => {
                this.userColumns.push({
                  text: el.fuserno
                })
              })
            }
            this.waterCostShow = true
            this.getWaterCostList()
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 查询水费账单
    getWaterCostList() {
      this.$http.post(this.$api.getFeeBill, { userno: this.fuserno }).then(res => {
        if (res.code === '000') {
          this.waterCostList = res.data.DETAIL
          // 有清单
          if (this.waterCostList.length > 0) {
            // 本期水费和用水量
            this.form.wtva = this.waterCostList[0].WTVA, //用水量
              this.form.tham = this.waterCostList[0].THAM,// 水费
              this.form.usad = res.data.USAD // 用水地址
            this.form.chst = this.waterCostList[0].CHST, //抄表周期
              this.form.toam = this.waterCostList[0].TOAM, //最后抄表日期
              // 拼接统计图
              this.getChartData()
          } else {
            // 没清单

          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 拼接返回数据
    getChartData() {
      let data = this.waterCostList
      let timeData = [] //时间
      let seriesData = [] // 用水量
      for (var i = data.length - 1; i >= 0; i--) {
        timeData.push(data[i].LZNY) // 时间
        seriesData.push(data[i].WTVA) // 用水量
        // 设置捏月
        data[i].month = data[i].LZNY.substring(4, 6)
        data[i].year = data[i].LZNY.substring(0, 4)
      }
      this.waterChart(timeData, seriesData)
    },
    // 图标
    waterChart(timeData, seriesData) {
      let myChart = EChart.init(this.$refs.accessChart);
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: timeData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '用水量',
          data: seriesData,
          type: 'bar',
          itemStyle: {
            color: EChart.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ]
            )
          },
          emphasis: {
            itemStyle: {
              color: EChart.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' }
                ]
              )
            }
          },
        }]
      }
      myChart.setOption(option, true)
    },
    // 选择缴费号
    onConfirm(data) {
      if (this.fuserno != data.text) {
        this.userList.forEach(el => {
          if (el.fuserno === data.text) {
            this.fname = el.fname
            this.fuserno = el.fuserno
          }
        })
        this.waterCostShow = true
        this.getWaterCostList()
      }
      this.dialogShow = false
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-field__label {
  color: #333;
  font-weight: bold;
  width: auto;
  font-size: 15px;
}
.chat-con {
  width: 92%;
  padding: 10px 4%;
  background: #fff;
  p {
    color: #333;
    font-size: 14px;
    line-height: 1.5em;
    margin: 0;
  }
  .label {
    flex: 1;
    height: 100%;
    p {
      color: #333;
      font-size: 14px;
      line-height: 1.5em;
      margin: 5px 0 5px 10px;
    }
    span {
      font-size: 10px;
      color: #777777;
    }
  }
}
.chat-bottom {
  display: flex;
  align-items: center;
  padding: 20px 2%;
  background: #fff;
  margin-top: 7px;
  .label-left {
    width: 70%;
    display: flex;
    align-items: center;
    .label-bot {
      width: 50%;
      p {
        margin: 10px 0;
        text-align: center;
        color: #333;
        font-size: 15px;
        font-weight: bold;
      }
      .info {
        text-align: center;
        color: #777;
        font-size: 10px;
        span {
          color: #3f83ff;
          font-size: 19px;
          margin-right: 6px;
        }
      }
    }
  }
  .button-right {
    border-left: 1px solid #eee;
    text-align: center;
    width: 30%;
    line-height: 65px;
    /deep/.van-button--small {
      padding: 2px 16px;
    }
  }
}
.center {
  text-align: center;
  height: 60px;
  line-height: 30px;
}

.info-query {
  // background:rgba(255,255,255,1);
  .top-tip {
    background: #fff9ed;
    padding: 8px 10px;
    line-height: 1.2em;
    .top-tip-txt {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff6010;
      /*text-align: center;*/
    }
  }

  .user-info {
    background: rgba(255, 255, 255, 1);
    padding: 10px 16px;

    .info-item {
      height: 30px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 33, 33, 1);

      .info-name {
        width: 70px;
      }

      .info-value {
        width: calc(~"100% - 70px");
      }
    }
  }

  .read-list {
    padding: 0 16px;

    .read-item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 5px 0px rgba(53, 126, 70, 0.08);
      border-radius: 4px;

      .main-table {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(33, 33, 33, 1);

        .main-col {
          min-height: 35px;
          border-left: 1px solid rgba(214, 216, 214, 1);
          border-top: 1px solid rgba(214, 216, 214, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
        }

        .main-col2 {
          min-height: 60px;
          border-left: 1px solid rgba(214, 216, 214, 1);
          border-top: 1px solid rgba(214, 216, 214, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
        }

        .main-label {
          background: rgba(240, 246, 241, 1);
        }

        .main-right {
          border-right: 1px solid rgba(214, 216, 214, 1);
        }

        .main-bottom {
          border-bottom: 1px solid rgba(214, 216, 214, 1);
        }
      }
    }
  }
}
.Water-bill {
  display: flex;
  align-items: center;
  // justify-content: center;
  margin-bottom: 10px;
  background: #fff;
  padding: 10px;
  .bill-circle {
    margin-right: 5%;
    border-radius: 50%;
    border: 1px solid #6096f8;
    width: 80px;
    height: 75px;
    text-align: center;
    line-height: 75px;
    span {
      color: #f89b60;
      font-size: 16px;
    }
    em {
      font-style: normal;
      color: #6096f8;
      font-size: 18px;
    }
    p {
      display: inline-block;
      color: #6096f8;
      font-size: 12px;
      margin: 0;
    }
  }
  .bill-con {
    font-size: 14px;
    color: #333;
    min-width: 42%;
    p {
      margin: 0;
    }
    span {
      color: #666;
    }
  }
  .bill-rig {
    color: #3f83ff;
    font-size: 14px;
    text-align: right;
    width: 35%;
    p {
      margin: 0;
      font-size: 18px;
    }
  }
}
.bill-bg {
  background: #e7f1ff;
  padding: 15px;
  font-size: 16px;
  color: #333;
  text-align: center;
}
/deep/.van-popup__close-icon {
  color: #666;
}
/deep/.van-popup--bottom {
  border-radius: 15px 15px 0 0;
}
.bill-p {
  color: #7aa8ea;
  margin: 0;
  text-align: center;
  font-size: 14px;
  background: #fff;
  padding: 20px 0;
}
.waterFee {
  background: #fff;
  margin: 10px 0 0 0;
  position: relative;
  &——title {
    font-size: 15px;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
  }
  &——head {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    padding: 0 2%;
    width: 96%;
    &__lift {
      height: 100%;
      width: 30%;
      flex: 1;
      font-size: 12px;
      // font-weight:bold;
      z-index: 99;
    }
    &__right {
      text-align: right;
      font-size: 14px;
      padding: 10px;
      height: 100%;
      width: 70%;
      margin-right: 10px;
      flex: 1;
      font-size: 12px;
      z-index: 99;
    }
  }
  &——content {
    min-height: 200px;
  }
}
</style>